import React from 'react';
import { useTranslation } from 'react-i18next'; // 1. ייבוא
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function CategoryFilter({ selectedCategory, onCategoryChange }) {
    const { t } = useTranslation(); // 2. הפעלה

    // 3. יצירת המערך באופן דינמי עם תרגומים
    const categories = [
        { value: 'all', label: t('categories.all') },
        { value: 'computer_science', label: t('categories.computer_science') },
        { value: 'judaism_philosophy', label: t('categories.judaism_philosophy') },
        { value: 'art', label: t('categories.art') },
        { value: 'neuroscience', label: t('categories.neuroscience') },
        { value: 'psychology', label: t('categories.psychology') },
        { value: 'other', label: t('categories.other') }
    ];

    return (
        <Select value={selectedCategory} onValueChange={onCategoryChange}>
            <SelectTrigger className="w-[200px]">
                {/* 4. תרגום ה-placeholder */}
                <SelectValue placeholder={t('forms.select_category')} />
            </SelectTrigger>
            <SelectContent className="bg-white">
                {categories.map((category) => (
                    <SelectItem key={category.value} value={category.value}>
                        {category.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}